import script from "./PriceChangeMonitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceChangeMonitoring.vue?vue&type=script&setup=true&lang=js"

import "./PriceChangeMonitoring.vue?vue&type=style&index=0&id=e3c2e6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3c2e6e8"]])

export default __exports__